/* tslint:disable */
/* eslint-disable */
/**
 * Ак Барс Недвижимость API
 * Инструменты разработчика:  [ [Документация API. Swagger](/docs/) ]  [ [Документация API. Redoc](/redoc/) ] [ [Панель администрирования](/admin/) ] [ [Документация Image-Service](/api/attachments/docs/) ]
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { AuthV1LoginListRequest, AuthV1RepeatPhoneConfirmRequest, AuthV1PhoneConfirmRequest } from '@/requests/mainApi';
/**
 *
 * @export
 * @interface Login
 */
export interface Login {
  /**
   *
   * @type {string}
   * @memberof Login
   */
  phone: string;
  /**
   *
   * @type {string}
   * @memberof Login
   */
  token: string;
}

export function LoginFromJSON(json: any): Login {
  return LoginFromJSONTyped(json, false);
}

export function LoginFromJSONTyped(json: any, ignoreDiscriminator: boolean): Login {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    phone: json['phone'],
    token: json['token'],
  };
}

export function LoginToJSON(value?: Login | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    phone: value.phone,
    token: value.token,
  };
}


export function SendPhoneConfirmToJSON(value?: AuthV1PhoneConfirmRequest | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }

  return {
    isAdmin: value.isAdmin,
    phone: value.phone,
    gRecaptchaResponse: value.gRecaptchaResponse,
    ignoreCaptchaKey: value.ignoreCaptchaKey,
  };
}



export function SendSmsCodeToJSON(value?: AuthV1LoginListRequest | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }

  return {
    isAdmin: value.isAdmin,
    phone: value.phone,
    gRecaptchaResponse: value.gRecaptchaResponse,
    checkAgreements: value.checkAgreements,
  };
}

export function SendRepeatPhoneConfirmToJSON(value?: AuthV1RepeatPhoneConfirmRequest | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }

  return {
    phone: value.phone,
  };
}



export function PhoneConfirmRequestToJSON(value?: AuthV1LoginListRequest | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }

  return {
    isAdmin: value.isAdmin,
    phone: value.phone,
    gRecaptchaResponse: value.gRecaptchaResponse,
    ignoreCaptchaKey: value.ignoreCaptchaKey,
    checkAgreements: value.checkAgreements,
  };
}

export function RepeatPhoneConfirmRequestToJSON(value?: AuthV1LoginListRequest | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }

  return {
    isAdmin: value.isAdmin,
    phone: value.phone,
    gRecaptchaResponse: value.gRecaptchaResponse,
    checkAgreements: value.checkAgreements,
  };
}